export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7771.c8a7a4b6.jpg";